// import SimilaritySearch from '../components/SimilaritySearch'
import XEUtils from "xe-utils";
import httpManager from "../../util/common";

let technique_field_search = {
  components: {},
  data: () => {
    return {
      search_oaid: null,
      tech_region: null,
      tech_theme: null,
      company_select: 'all',
      loading: false,
      exportConfig: {},
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 20,
        align: 'center',
        pageSizes: [10, 20, 50, 100, 200, 500],
        layouts: ['PrevPage', 'Number', 'NextPage'],
        perfect: true,
        pagerCount: 3
      },
      company_select_options: [
        {label: '全部公司', value: 'all'},
        {label: '上市公司', value: 'listed_company'}
      ],
      tech_region_options: [
        {label: '电气工程', value: '电气工程', children: [
          {label: '电机，设备，能源', value: '1'},
          {label: '视听技术', value: '2'},
          {label: '电信', value: '3'},
          {label: '数字通信', value: '4'},
          {label: '基本通信处理', value: '5'},
          {label: '计算机技术', value: '6'},
          {label: '信息技术管理方法', value: '7'},
          {label: '半导体', value: '8'}
          ]},
        {label: '机械工程', value: '机械工程', children: [
          {label: '机械处理', value: '25'},
          {label: '机械工具', value: '26'},
          {label: '发动机，水泵，涡轮机', value: '27'},
          {label: '防治和造纸机械', value: '28'},
          {label: '其他专用机械', value: '29'},
          {label: '热处理和设备', value: '30'},
          {label: '机械元件', value: '31'},
          {label: '运输系统', value: '32'}
          ]},
        {label: '仪器', value: '仪器', children: [
          {label: '光学器件', value: '9'},
          {label: '测量', value: '10'},
          {label: '生物材料分析', value: '11'},
          {label: '控制', value: '12'},
          {label: '医疗技术', value: '13'}
          ]},
        {label: '化学', value: '化学', children: [
          {label: '有机精细化学', value: '14'},
          {label: '生物技术', value: '15'},
          {label: '制药', value: '16'},
          {label: '高分子化学，聚合物', value: '17'},
          {label: '食品化学', value: '18'},
          {label: '基础材料化学', value: '19'},
          {label: '材料，冶金', value: '20'},
          {label: '表面技术，涂层', value: '21'},
          {label: '微观结构和纳米技术', value: '22'},
          {label: '化学工程', value: '23'},
          {label: '环境技术', value: '24'}
          ]},
        {label: '其他领域', value: '其他领域', children: [
          {label: '家具，游戏', value: '33'},
          {label: '其他生活消费品', value: '34'},
          {label: '土木工程', value: '35'}
          ]}
      ],
      tech_theme_options: [
        {label: '新能源', value: 'theme_newenergy'},
        {label: '5G', value: 'theme_5g'},
        {label: '云计算', value: 'theme_cloudcomputing'},
        {label: '人工智能', value: 'theme_ai'},
        {label: '半导体', value: 'theme_semiconductor'},
        {label: '新型汽车', value: 'theme_newvehicle'}
      ],
      data: []
    }
  },
  methods: {
    cellClickEvent ({row, column}) {
      if (column.property === 'entname') {
        const {
          href
        } = this.$router.resolve({path: '/entity/' + row.oaid + '/patent/detail'})
        window.open(href, '_blank')
      }
    },
    pageChange ({ currentPage, pageSize }) {
      this.page.currentPage = currentPage
      this.page.pageSize = pageSize
      this.getTechniqueFieldSearchTableData()
    },
    openDataExport (value, selectedOptions) {
      console.log('openDataExport')
    },
    clearData () {
      this.data = []
      this.page.pageSize = 20
      this.page.currentPage = 1
      this.page.total = 0
      this.tech_region = null
    },
    searchTechRegionData () {
      this.getTechniqueFieldSearchTableData()
    },
    techRegionOnChange (value, selectedOptions) {
      if (value.length !== 1) {
        this.tech_region = value
      }
    },
    techRegionFilter (inputValue, path) {
      return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    },
    getTechniqueFieldSearchTableData () {
      let self = this
      if (self.tech_region || self.tech_theme) {
        self.loading = true
        let params = new Map()
        params.set('pagenum', self.page.currentPage)
        params.set('pagesize', self.page.pageSize)
        params.set('company_select', self.company_select)
        if (self.tech_region) {
          params.set('tech_region', self.tech_region[1])
        }
        if (self.tech_theme) {
          params.set('tech_theme', self.tech_theme)
        }
        if (params.length === 0) {
          return
        }
        httpManager('technique_field_search', params, null, null, null)
          .then(response => {
            let resultData = []
            if (response.data.data.length > 0) {
              response.data.data.forEach(function (row) {
                let num = null
                let ratio = null
                if (self.tech_region) {
                  num = row.technique[self.tech_region[1]]
                  ratio = row.technique[self.tech_region[1]] * 100 / row.total
                } else {
                  num = row[self.tech_theme]
                  ratio = row[self.tech_theme] * 100 / row.total
                }
                resultData.push({'entname': row.entname, 'ticker': row.ticker, 'oaid': row.oaid, 'num': num, 'ratio': ratio})
              })
            }
            self.data = resultData
            let page = response.data.page
            self.page.total = page.total
            self.loading = false
          })
          .catch(error => {
            console.log(error)
            self.loading = false
          })
      }
    }
  },
  watch: {
    tech_region: function () {
      this.page.currentPage = 1
      if (this.tech_region && this.tech_region.length > 1) {
        this.tech_theme = null
        this.getTechniqueFieldSearchTableData()
      }
    },
    tech_theme: function () {
      this.page.currentPage = 1
      this.tech_region = null
      this.getTechniqueFieldSearchTableData()
    },
    company_select: function () {
      this.page.currentPage = 1
      this.getTechniqueFieldSearchTableData()
    }
  },
  computed: {
    tableColumn() {
      return [
        {type: 'seq', width: 50},
        {title: this.$t('patent.company_insitution_name'), field: 'entname', className: 'click-cell-style'},
        {title: this.$t('patent.security_code'), field: 'ticker'},
        {title: this.$t('patent.current_options_patent_number'), field: 'num', formatter: ({cellValue}) => {
          return cellValue ? `${XEUtils.commafy(XEUtils.toNumber(cellValue), {digits: 0})}` : ''}},
        {title: this.$t('patent.current_options_patent_number_total_number'), field: 'ratio', formatter: ({cellValue}) => {
          return cellValue ? `${XEUtils.commafy(XEUtils.toNumber(cellValue), {digits: 2})}` : ''}}
      ]
    }
  }
}
export default technique_field_search



// WEBPACK FOOTER //
// ./src/patent/js/technique_field_search.js